var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"system-log-item__title",domProps:{"innerHTML":_vm._s(_vm.logText)}})}
var staticRenderFns = []

export { render, staticRenderFns }